import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { isCheckModuleActionForNavigationPath } from "src/helpers/userAccessFun";
import { UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";
import { RootState } from "src/redux/store";

type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const PendingFollowupListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  const { userType } = useSelector((state: RootState) => state.auth);

  const navigate = useNavigate();
  return (
    <SideNavLayout>
      <div className="flex flex-col p-4">
        {/* Page Header */}
        <div className="p-4">
          <ATMPageHeader
            pageTitle="FollowUps"
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            hideAddButton
          />
        </div>

        {/* Table */}
        <div className="flex-1 overflow-auto flex flex-col">
          <ATMTable
            columns={columns}
            rows={rows}
            onRowClick={(row: any) => {
              if (userType === "ADMIN") {
                navigate(`/inquiries/edit/${row?.inquiry_id}/followup`)
              } else {
                (isCheckModuleActionForNavigationPath(UserModuleNameTypes.INQUIRIES, `/inquiries/edit/${row?.inquiry_id}`, navigate))
              }
            }
            }
            rowExtraClasses={() => "min-h-[40px]"}
            isLoading={isTableLoading}
          />
        </div>

        <div className="p-4 py-2 flex justify-end">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
      </div>
    </SideNavLayout>
  );
};

export default PendingFollowupListing;
